export const MergeDistributionModal: string = 'MergeDistributionModal';
